import PropTypes from "prop-types"

export const SECURITY = PropTypes.shape({
  type: PropTypes.string.isRequired,
  key: PropTypes.string.isRequired,
  exchange: PropTypes.string,
  ticker: PropTypes.string,
  size: PropTypes.number.isRequired,
  percEquity: PropTypes.number.isRequired,
  descriptors: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])),
  factors: PropTypes.objectOf(PropTypes.number),
})

export const AGGREGATION = PropTypes.shape({
  type: PropTypes.string.isRequired,
  key: PropTypes.string.isRequired,
  aggregationType: PropTypes.string.isRequired,
  open: PropTypes.bool,
  size: PropTypes.number.isRequired,
  percEquity: PropTypes.number, // absent from net aggregation
  descriptors: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])),
  factors: PropTypes.objectOf(PropTypes.number),
})

export const BASE = PropTypes.shape({
  type: PropTypes.string.isRequired,
  key: PropTypes.string.isRequired,
  percEquity: PropTypes.number, // absent from active row
  factors: PropTypes.objectOf(PropTypes.number),
})

export const FACTOR = PropTypes.shape({
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  getValue: PropTypes.func.isRequired,
  formatter: PropTypes.func.isRequired,
})

export const GROUP = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
})
